import { cssVar, Flex, IconButton, Box } from '@cad-arc';
import { FC } from 'react';
import { ESRI_MAP_MAX_ZOOM_LEVEL, ESRI_MAP_MIN_ZOOM_LEVEL } from '../configurations';
import { useZoomInAndOutControl } from '../hooks/use-zoom-in-and-out-control';
import type { UseZoomInAndOutControl } from '../hooks/use-zoom-in-and-out-control';

type ZoomInANdOutControlProps = UseZoomInAndOutControl;
export const ZoomInAndOutControl: FC<ZoomInANdOutControlProps & { btnSize?: string }> = ({
    mapView,
    maxZoomLevel = ESRI_MAP_MAX_ZOOM_LEVEL,
    minZoomLevel = ESRI_MAP_MIN_ZOOM_LEVEL,
    btnSize = 'lg',
}) => {
    const { onZoomOut, onZoomIn } = useZoomInAndOutControl({
        mapView,
        maxZoomLevel,
        minZoomLevel,
    });
    return (
        <Flex
            direction="column"
            h="100%"
            position="absolute"
            justifyContent="center"
            right="10px"
            zIndex={cssVar('arc.zIndices.tooltip')}
        >
            <Box mb={1}>
                <IconButton aria-label="zoom in map" icon="Add" size={btnSize} onClick={onZoomIn} />
            </Box>
            <IconButton aria-label="zoom out map" icon="Close" size={btnSize} onClick={onZoomOut} />
        </Flex>
    );
};
